import React from 'react';
import { motion } from 'framer-motion';
export function HeroPanel() {
  return <section className="w-full bg-petrol text-white min-h-[80vh] flex flex-col justify-center relative overflow-hidden" data-id="element-125">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-petrol-dark opacity-50 transform skew-x-12 translate-x-1/4" data-id="element-126"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full relative z-10 py-20" data-id="element-127">
        <motion.div className="w-full" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-128">
          <div className="mb-12" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/hDufW1VXXqt2oYDEB9Khc1/HofelmeyerLogo_(1)_(4).png" alt="Höfelmeyer" className="h-[6.9rem] md:h-[10.35rem] w-auto mb-4 -ml-[30px]" data-id="element-130" />
            <div className="flex items-center gap-4 my-4" data-id="element-131">
              <div className="h-1 w-12 bg-hoefelmeyer-green" data-id="element-132"></div>
              <span className="text-hoefelmeyer-green text-3xl font-light" data-id="element-133">
                ×
              </span>
              <div className="h-px flex-1 bg-hoefelmeyer-green/30" data-id="element-134"></div>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/w1fkE9QTm8c5d5hXfLFQWp/MI_Logo_RGB[30].png" alt="Minebea Intec" className="h-24 md:h-36 w-auto bg-white rounded-md px-4 py-2" data-id="element-135" />
          </div>

          <p className="text-xl md:text-2xl font-light text-slate-300 max-w-2xl mb-16 leading-relaxed" data-id="element-136">
            Partnerschaft für präzise Wägetechnik.
          </p>

          <div className="flex flex-wrap gap-6 text-xs font-medium tracking-widest text-slate-400 uppercase" data-id="element-137">
            <div className="flex items-center gap-2" data-id="element-138">
              <span className="w-1.5 h-1.5 rounded-full bg-hoefelmeyer-green" data-id="element-139"></span>
              Edition 2026
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}